import React from "react";
import Link from "next/link";
import { docsColors } from "@/lib/docs-theme";

interface DocLinkProps {
  href: string;
  children: React.ReactNode;
  className?: string;
  external?: boolean;
}

export default function DocLink({
  href,
  children,
  className = "",
  external = false,
}: DocLinkProps) {
  const defaultClassName = docsColors.link.primary;
  const finalClassName = className ? `${defaultClassName} ${className}` : defaultClassName;

  if (external) {
    return (
      <a href={href} className={finalClassName} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    );
  }

  return (
    <Link href={href} className={finalClassName}>
      {children}
    </Link>
  );
}
